/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
const AddressesListing = require('react').lazy(() => import('../components/Feature/AddressesListing/AddressesListing'));
const Banner = require('react').lazy(() => import('../components/Feature/Banner/Banner'));
const Cards = require('react').lazy(() => import('../components/Feature/Cards/Cards'));
const Content = require('react').lazy(() => import('../components/Feature/Content/Content'));
const ContextualBanner = require('react').lazy(() => import('../components/Feature/ContextualBanner/ContextualBanner'));
const EngagementsBlockCards = require('react').lazy(() => import('../components/Feature/EngagementsBlockCards/EngagementsBlockCards'));
const Footer = require('react').lazy(() => import('../components/Feature/Footer/Footer'));
const Gallery = require('react').lazy(() => import('../components/Feature/Gallery/Gallery'));
const GalleryListing = require('react').lazy(() => import('../components/Feature/GalleryListing/GalleryListing'));
const Header = require('react').lazy(() => import('../components/Feature/Header/Header'));
const InitiativesAndPatronages = require('react').lazy(() => import('../components/Feature/InitiativesAndPatronages/InitiativesAndPatronages'));
const InitiativesAndPatronagesWidget = require('react').lazy(() => import('../components/Feature/InitiativesAndPatronagesWidget/InitiativesAndPatronagesWidget'));
const KeyFactsBlock = require('react').lazy(() => import('../components/Feature/KeyFactsBlock/KeyFactsBlock'));
const LatestAddresses = require('react').lazy(() => import('../components/Feature/LatestAddresses/LatestAddresses'));
const LatestNews = require('react').lazy(() => import('../components/Feature/LatestNews/LatestNews'));
const NewsListing = require('react').lazy(() => import('../components/Feature/NewsListing/NewsListing'));
const PersonalizeLatestNews = require('react').lazy(() => import('../components/Feature/PersonalizeLatestNews/PersonalizeLatestNews'));
const PersonalizeTimeline = require('react').lazy(() => import('../components/Feature/PersonalizeTimeline/PersonalizeTimeline'));
const QuotesListing = require('react').lazy(() => import('../components/Feature/QuotesListing/QuotesListing'));
const RelatedNews = require('react').lazy(() => import('../components/Feature/RelatedNews/RelatedNews'));
const Search = require('react').lazy(() => import('../components/Feature/Search/Search'));
const SearchSnapshot = require('react').lazy(() => import('../components/Feature/SearchSnapshot/SearchSnapshot'));
const Testimonial = require('react').lazy(() => import('../components/Feature/Testimonial/Testimonial'));
const Timeline = require('react').lazy(() => import('../components/Feature/Timeline/Timeline'));
const Video = require('react').lazy(() => import('../components/Feature/Video/Video'));

const components = new Map();
components.set('AddressesListing', AddressesListing);
components.set('Banner', Banner);
components.set('Cards', Cards);
components.set('Content', Content);
components.set('ContextualBanner', ContextualBanner);
components.set('EngagementsBlockCards', EngagementsBlockCards);
components.set('Footer', Footer);
components.set('Gallery', Gallery);
components.set('GalleryListing', GalleryListing);
components.set('Header', Header);
components.set('InitiativesAndPatronages', InitiativesAndPatronages);
components.set('InitiativesAndPatronagesWidget', InitiativesAndPatronagesWidget);
components.set('KeyFactsBlock', KeyFactsBlock);
components.set('LatestAddresses', LatestAddresses);
components.set('LatestNews', LatestNews);
components.set('NewsListing', NewsListing);
components.set('PersonalizeLatestNews', PersonalizeLatestNews);
components.set('PersonalizeTimeline', PersonalizeTimeline);
components.set('QuotesListing', QuotesListing);
components.set('RelatedNews', RelatedNews);
components.set('Search', Search);
components.set('SearchSnapshot', SearchSnapshot);
components.set('Testimonial', Testimonial);
components.set('Timeline', Timeline);
components.set('Video', Video);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
